import { z } from "zod";

const schema = z.object({
  VITE_API_URL: z.string().default("/api/v1"),
  VITE_APP_NAME: z.string().default("MADA"),
  VITE_DEFAULT_LOCALE: z.string().default("fr-FR"),
  VITE_DEFAULT_CURRENCY: z.string().default("GNF"),
});

export const env = schema.parse({
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_APP_NAME: import.meta.env.VITE_APP_NAME,
  VITE_DEFAULT_LOCALE: import.meta.env.VITE_DEFAULT_LOCALE,
  VITE_DEFAULT_CURRENCY: import.meta.env.VITE_DEFAULT_CURRENCY,
});
